import { roundMoney, sumMoney, toMoney } from './money.js';
import type { JournalLine } from './schemas.js';

export type { JournalLine } from './schemas.js';

export function validateJournalBalance(lines: JournalLine[]): {
  valid: boolean;
  debitTotal: string;
  creditTotal: string;
  error?: string;
} {
  if (!lines.length) {
    return { valid: false, debitTotal: '0.00', creditTotal: '0.00', error: 'No lines' };
  }
  let hasAmount = false;
  for (const line of lines) {
    const d = toMoney(line.debit);
    const c = toMoney(line.credit);
    if (d.gt(0) && c.gt(0)) {
      return {
        valid: false,
        debitTotal: '0.00',
        creditTotal: '0.00',
        error: 'Line cannot have both debit and credit'
      };
    }
    if (d.gt(0) || c.gt(0)) hasAmount = true;
  }
  if (!hasAmount) {
    return { valid: false, debitTotal: '0.00', creditTotal: '0.00', error: 'No amounts' };
  }
  const debitTotal = sumMoney(lines.map((l) => l.debit));
  const creditTotal = sumMoney(lines.map((l) => l.credit));
  if (debitTotal !== creditTotal) {
    return { valid: false, debitTotal, creditTotal, error: 'Debits must equal credits' };
  }
  return { valid: true, debitTotal, creditTotal };
}

export function normalizeJournalLine(line: JournalLine): JournalLine {
  return {
    ...line,
    debit: roundMoney(line.debit),
    credit: roundMoney(line.credit)
  };
}
